module.exports = __webpack_public_path__ + "images/emoji/dog2.65d7cdd80fc02a0ddac4.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/dog2.png
// module id = G6u9
// module chunks = 13